import REPORT from './Report';

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/VoiceAPiCdr/components/index.js